
export const getCnpjRoot = (value) => {
    if (!value) return null

    const cnpj = String(value).replace(/\D/g, "")
    return cnpj.length === 14 ? cnpj.slice(0, 8) : null
}